import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-crm-menu',
    templateUrl: './crm-menu.component.html',
    styleUrls: ['./crm-menu.component.css'],
})
export class CrmMenuComponent {
    /**
     * The name of the crm webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
